import { Box } from '@mui/material';
import * as React from 'react';

import { DataAPIContext, GET_ONE } from '../api';
import FixedLinearProgress from './FixedLinearProgress';
import { HTTPError } from './HTTPError';

export const RecordDetailsContext = React.createContext();
RecordDetailsContext.displayName = 'RecordDetailsContext';

export const RecordDetails = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const resource = props.resource;
    const [details, setDetails] = React.useState(null);
    const [refresh, setRefresh] = React.useState(null);
    const [error, setError] = React.useState(null);
    React.useEffect(() => {
        let active = true;
        setError(null);

        (async () => {
            const res = await dataAPI(GET_ONE, resource, { id: props.id });
            if (!active) {
                return;
            }
            if (res.statusCode >= 400 && res.statusCode < 600) {
                setError(res.statusCode);
            } else {
                setDetails(
                    props.fullResponse
                        ? {
                              ...res,
                              api: {
                                  refresh: () => setRefresh(new Date().toString()),
                              },
                          }
                        : res.data
                );
                props.onLoad && props.onLoad(res.data);
            }
        })();

        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataAPI, resource, props.id, props.data, refresh]);
    const loadingCmp = props.loading || (
        <Box m={2}>
            <FixedLinearProgress alwaysShow={true} />

            <h4>
                Loading {props.resource.replace('_', ' ')} {props.id}...
            </h4>
        </Box>
    );
    if (error) {
        return <HTTPError resource={resource} id={props.id} code={error} />;
    } else if (!details) {
        return loadingCmp;
    } else {
        return <RecordDetailsContext.Provider value={details}>{props.children}</RecordDetailsContext.Provider>;
    }
};

export default RecordDetails;
